export const marketingFormData = () => {
  return [
    {
      id: "nama_marketing",
      label: "Nama Marketing",
      fields: [
        {
          type: "input",
          placeholder: "Masukan Nama Marketing",
        },
      ],
    },
    {
      id: "no_hp_marketing",
      label: "Nomor Hp Marketing",
      fields: [
        {
          type: "input",
          placeholder: "Masukan Nomor HP Marketing",
        },
      ],
    },
  ];
};
